module.exports = new __parcel__URL__("Priestskill_10.8303df6d.png").toString();